import { computed, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { PackagesSelectors, ProductType } from 'src/app/features/packages';
import { CheckInSelectors } from 'src/app/features/check-in/store';
import { MsalAuthSelectors } from 'src/app/features/msal-auth/store/selectors';
import { ESIGN_HANDOFF_STATE } from 'src/app/features/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class SessionHandoffService {
  private readonly redirectState = this.store.selectSignal(MsalAuthSelectors.getRedirectState);
  private readonly productType = this.store.selectSignal(PackagesSelectors.getProductType);
  private readonly isRejoining = this.store.selectSignal(CheckInSelectors.isRejoining);

  readonly shouldShowSessionHandoffComponent = computed(() => {
    // Rejoining participants always use the legacy flow, regardless of how they arrived.
    if (this.isRejoining()) {
      return false;
    }

    return this.redirectState() === ESIGN_HANDOFF_STATE &&
      this.productType() === ProductType.RemoteSigning;
  });

  constructor(private readonly store: Store) {}
}
